import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { Spacer, PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { TransactionsTab } from "./transactions";
import { DataTab } from "./accountData";
import { RejectedAuthorizationsTab } from "./rejectedAuthorizations";
import { CompanyFollowUpTab } from "./followUp";
import "../../i18n/i18n";
import { useAppSelector } from "../../redux/hooks";
import { selectAdminUser } from "../homeSlice";
import { BalanceLimitsTab } from "./balanceLimits";
import { CompaniesDeletedTab } from "./companiesDeleted";

export const CompaniesData = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "accountData",
  );
  const adminUser = useAppSelector(selectAdminUser);

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/home/companies_data/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  const tabs = useMemo(() => {
    const tabs = [
      {
        name: "accountData",
        title: t("companiesData.tab.accountData"),
      },

      {
        name: "transactions",
        title: t("companiesData.tab.transactions"),
      },
      {
        name: "authorizations",
        title: t("companiesData.tab.rejectedAuthorizations"),
      },
      {
        name: "balanceLimits",
        title: t("companiesData.tab.balanceLimits"),
      },
      {
        name: "companiesDeleted",
        title: t("companiesData.tab.companiesDeleted"),
      },
    ];

    if (adminUser?.email !== "exterieur1@qivia.fr") {
      tabs.push({
        name: "companyFollowUp",
        title: t("companiesData.tab.companyFollowUp"),
      });
    }
    return tabs;
  }, [adminUser?.email, t]);

  return (
    <PageDS
      title={t(`companiesData.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <TransactionsTab />
      <DataTab />
      <RejectedAuthorizationsTab />
      <CompanyFollowUpTab />
      <BalanceLimitsTab />
      <CompaniesDeletedTab />
    </PageDS>
  );
};
